import * as React from 'react';

// Utils
import { withUserWebView } from '@shopee-user/with-web-view';

// Components
import { FoodDriverHelpTextSpan } from '../components/FoodDriverHelpTextSpan';

// Constants
import { constants } from '@shopee-user/food-driver-customization-logic';

// Types
import { WithUserWebViewProps } from '@shopee-user/with-web-view';

type Props = {
  text: string;
  onClick?: () => void;
} & WithUserWebViewProps;

/**
 * Base help button to navigate to help url
 */
const BaseButton = ({ text, onClick, webViewNavigateToUrl }: Props) => {
  if (!text || !constants.AUTHENTICATE_HELP_LINK) {
    return null;
  } else {
    return (
      <FoodDriverHelpTextSpan
        onClick={() => {
          if (onClick) {
            onClick();
          }
          webViewNavigateToUrl(constants.AUTHENTICATE_HELP_LINK);
        }}
      >
        {text}
      </FoodDriverHelpTextSpan>
    );
  }
};

/**
 * Use `webViewNavigateToUrl` to navigate to `AUTHENTICATE_HELP_LINK`
 */
export const AuthenticationHelpButton = withUserWebView({})(BaseButton);
